export const sizeConfigs = {
  sidebar: {
    width: "20%",
  },
};
